import React, { useMemo, useState } from 'react';
import { pathgen } from 'object-path-generator';
import { Checkbox, Column, FilterPicker, Row, Searchbox, Typography } from 'seagull';
import { serviceCostModel } from "../../models";
import { ServiceCostType } from "../../models/service-cost";
import styles from "./AddServicesFilterPicker.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AddServicesFilterPickerTestIds = pathgen('AddServicesFilterPickerTestIds');
function formatPrice(price, pricingType) {
  if (pricingType === ServiceCostType.Fixed) return "$".concat(price);
  if (pricingType === ServiceCostType.Range) return "$".concat(price, " - $").concat(price);
  return "$".concat(price, "/h");
}
function filterTemplates(serviceTemplates, searchTerm) {
  if (!searchTerm.trim()) {
    return serviceTemplates;
  }
  return serviceTemplates.filter(template => template.name.toLowerCase().includes(searchTerm.toLowerCase()));
}
const AddServicesFilterPicker = _ref => {
  let {
    serviceTemplates,
    selectedServiceTemplateIds,
    hasError,
    testId,
    onApply: _onApply,
    onClose: handleClose,
    onToggle
  } = _ref;
  const [searchTerm, setSearchTerm] = useState('');
  const filteredTemplates = useMemo(() => filterTemplates(serviceTemplates, searchTerm), [serviceTemplates, searchTerm]);
  const headerContent = /*#__PURE__*/_jsx(Searchbox, {
    className: styles.searchbox,
    testId: AddServicesFilterPickerTestIds.SearchInput(),
    placeholder: "Search",
    value: searchTerm,
    onChange: e => setSearchTerm(e.target.value),
    onClear: () => setSearchTerm('')
  });
  const onClose = options => {
    handleClose(options);
    setTimeout(() => setSearchTerm(''), 100);
  };
  return /*#__PURE__*/_jsx(FilterPicker, {
    testId: testId,
    title: "Add services",
    label: "+ Add services",
    buttonTitle: "+ Add services",
    highlightTrigger: false,
    onApply: () => _onApply(selectedServiceTemplateIds),
    onClose: onClose,
    headerContent: headerContent,
    popoverWidth: 400,
    type: "textButton",
    hasError: hasError,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.serviceItemsWrapper,
      children: [filteredTemplates.map(template => {
        const isSelected = selectedServiceTemplateIds.includes(template.id);
        const discountedPrice = serviceCostModel.finalPrice(template.cost, 1);
        return /*#__PURE__*/_jsxs(Row, {
          onClick: () => onToggle(template.id),
          testId: AddServicesFilterPickerTestIds.ServiceItem(template.id),
          className: styles.serviceItem,
          children: [/*#__PURE__*/_jsx(Checkbox, {
            testId: AddServicesFilterPickerTestIds.ServiceCheckbox(template.id),
            checked: isSelected
          }), /*#__PURE__*/_jsxs(Column, {
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph1",
              children: template.name
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph2",
              skin: "secondary",
              testId: AddServicesFilterPickerTestIds.ServiceItemPrice(template.id),
              children: formatPrice(discountedPrice, template.cost.pricingType)
            })]
          })]
        }, template.id);
      }), filteredTemplates.length === 0 && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        skin: "secondary",
        children: "No services found"
      })]
    })
  });
};
export default AddServicesFilterPicker;